import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Portuguese Citizen Card generator following Single Responsibility Principle
 */
export class PtGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true } = options;

    // Generate 8 random digits
    const digits = this.randomDigits(8);
    
    // Calculate check digit
    let sum = 0;
    for (let i = 0; i < 8; i++) {
      sum += parseInt(digits[i]) * (9 - i);
    }
    
    const remainder = sum % 11;
    const checkDigit = remainder >= 10 ? 0 : remainder;
    
    // Generate version (1 digit)
    const version = this.randomInt(0, 9);
    
    // Generate control letters (2 letters)
    const controlLetters = this.randomLetter() + this.randomLetter();
    
    // Generate final digit
    const finalDigit = this.randomInt(0, 9);
    
    const citizenCard = digits + checkDigit + version + controlLetters + finalDigit;
    
    return formatted ? 
      `${citizenCard.substring(0, 8)} ${citizenCard.substring(8, 9)} ${citizenCard.substring(9, 12)}` : 
      citizenCard;
  }
}